import Colorful from '@uiw/react-color-colorful';
import { useTranslations } from '@power-core/toolkit';
import type { FunctionComponent } from 'react';
import { Dropdown } from '@/ui-components/dropdown/dropdown';
import { LabelBadge } from '@/ui-components/label-badge/label-badge';
import type { ColorPickerProps } from './types';

export const ColorPicker: FunctionComponent<ColorPickerProps> = ({ color, isDisabled, label, onColorChange = () => {} }) => {
	const t = useTranslations();
	const colorPopUp = [
		{
			value: 'COLOR_PICKER',
			label: <Colorful disableAlpha color={color ?? ''} onChange={(color) => onColorChange(color.hex)} />,
		},
	];

	return (
		<Dropdown
			disabled={isDisabled}
			header={color}
			isMenu
			inline
			dismissOnClick={false}
			arrowIcon={false}
			className='flex-grow'
			label={
				<LabelBadge
					text={label ? label : t('T_SELECT_COLOR')}
					background={`${color}20`}
					color={color}
					size='small'
					className='w-full'
					pill
				/>
			}
			menuItems={colorPopUp}
		/>
	);
};
